import GPSelect from '@gp/components/Select';
import { CONSTANT_TEXTS } from '@gp/constants/const';
import { BoolFlag, DataType } from '@gp/enums/common';
import { MilestoneDateStatus } from '@gp/enums/milestone';
import { CommonColumnBuilders, ICommonColumnChangeHandler } from '@gp/utils/columns';
import { generateMockId, isMockId, toStdOptions } from '@gp/utils/common';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
import React from 'react';
import { TableColumn } from 'tea-component';
import { DPS_REPORT_FORM_CONTROL_PLACEHOLDER } from '../../../constants';
import { getIsDisabled } from '../../../utils';
import { buildProjectSelectColumn } from '../../../utils/columns';

import type {
  IDPSReportCalendarProjectSimpleVO,
  IDPSReportCalendarVO,
} from '@gp/types/dpsReport/common';
import type { IMilestoneSimpleDTO, IRecord } from '@gp/types/global';

export const CARD_TITLE = 'Calendar';

export const buildRecord = (): IDPSReportCalendarVO => ({
  mock_id: generateMockId(),
  data_type: DataType.ManualAdded,
  project_id: '',
  project: '',
  platform: [],
  image_name: '',
  cover: '',
  priority: '',
  business_owner: '',
  pteam: '',
  studio: '',
  studio_id: '',
  milestone_id: '',
  milestone: '',
  date_confirm: MilestoneDateStatus.Confirm,
  date: '',
  is_gr: BoolFlag.False,
  is_launch: BoolFlag.False,
  status: '',
});

export const getColumns = (props: {
  // Milestone是否固定支持编辑
  isMilestoneKeepEditable?: boolean;
  columnWidthMapping?: IRecord<number | string | undefined>;
  projects?: IDPSReportCalendarProjectSimpleVO[] | null;
  milestonesMapping?: IRecord<IMilestoneSimpleDTO[]> | null;
  onProjectChange?: (payload: string, cvm: IDPSReportCalendarVO) => void;
  onMilestoneChange?: (payload: string, cvm: IDPSReportCalendarVO) => void;
  onChange?: ICommonColumnChangeHandler<IDPSReportCalendarVO>;
}) => {
  const {
    isMilestoneKeepEditable = false,
    columnWidthMapping,
    projects,
    milestonesMapping,
    onProjectChange,
    onMilestoneChange,
    onChange,
  } = props || {};

  const projectsOptions = toStdOptions<IDPSReportCalendarProjectSimpleVO>(projects, {
    text: 'project',
    value: 'project_id',
  });

  return [
    // CommonColumnBuilders.buildPureTextColumn({
    //   key: 'priority',
    //   header: 'Priority',
    //   width: columnWidthMapping?.priority ?? 100,
    //   formatter: (cvm) => {
    //     const { priority } = cvm || {};
    //     return <MorePriorityTag showIcon={false} value={priority} />;
    //   },
    // }),
    buildProjectSelectColumn({
      showTextWhenSelected: false,
      width: columnWidthMapping?.project_id,
      options: projectsOptions,
      onChange: onProjectChange,
    }),
    CommonColumnBuilders.buildPureTextColumn({
      key: 'business_owner',
      header: 'BO',
      width: columnWidthMapping?.business_owner,
    }),
    CommonColumnBuilders.buildPureTextColumn({
      key: 'pteam',
      header: 'P-team',
      width: columnWidthMapping?.pteam,
    }),
    {
      key: 'milestone_id',
      align: 'left',
      header: CONSTANT_TEXTS.MILESTONE,
      width: columnWidthMapping?.milestone_id,
      render: (cvm) => {
        const {
          mock_id: mockId,
          project_id: projectId,
          milestone_id: milestoneId,
          milestone,
        } = cvm || {};
        if (!isMilestoneKeepEditable && !isMockId(mockId)) return milestone || '-';
        const disabled = getIsDisabled(cvm);
        const milestones = milestonesMapping?.[projectId];
        const milestonesOptions = toStdOptions<IMilestoneSimpleDTO>(milestones, {
          text: 'milestone',
          value: 'milestone_id',
        });
        return (
          <GPSelect
            className="dbg-dps-report__milestone-select"
            placeholder={DPS_REPORT_FORM_CONTROL_PLACEHOLDER}
            clearable={false}
            disabled={disabled}
            button={milestone}
            options={milestonesOptions}
            value={milestoneId}
            onChange={(payload) => {
              onMilestoneChange?.(payload, cvm);
            }}
          />
        );
      },
    },
    CommonColumnBuilders.buildPureTextColumn({
      key: 'date',
      header: CONSTANT_TEXTS.MILESTONE_TIME,
      width: columnWidthMapping?.date ?? 170,
      formatter: (cvm) => formatMilestoneDateByStatus(cvm?.date, cvm?.date_confirm),
    }),
    CommonColumnBuilders.buildTextareaColumn({
      key: 'status',
      header: 'Status',
      width: columnWidthMapping?.status,
      placeholder: 'Please input Status',
      getIsDisabled: (cvm: IDPSReportCalendarVO) => getIsDisabled(cvm),
      onChange,
      isCalendar: true,
    }),
  ] as TableColumn<IDPSReportCalendarVO>[];
};
